/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoApiRoleListRequest model module.
 * @module model/SystemControllerDtoApiRoleListRequest
 * @version 1.0
 */
class SystemControllerDtoApiRoleListRequest {
    /**
     * Constructs a new <code>SystemControllerDtoApiRoleListRequest</code>.
     * @alias module:model/SystemControllerDtoApiRoleListRequest
     */
    constructor() { 
        
        SystemControllerDtoApiRoleListRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoApiRoleListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoApiRoleListRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoApiRoleListRequest} The populated <code>SystemControllerDtoApiRoleListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoApiRoleListRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoApiRoleListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoApiRoleListRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} gnbNo
 */
SystemControllerDtoApiRoleListRequest.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoApiRoleListRequest.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
SystemControllerDtoApiRoleListRequest.prototype['subNo'] = undefined;






export default SystemControllerDtoApiRoleListRequest;

